const MEMBERSHIP_LABEL = {
  C: "Complimentary",
  P: "Premier",
};

const PIN_ORDER = ["IBO", "PLA", "EME", "DIA"];
const PIN_LABEL = {
  IBO: "IBOs",
  PLA: "Platinums",
  EME: "Emeralds",
  DIA: "Diamonds",
};

const buildPinPhrase = (pins) => {
  const allowed = PIN_ORDER.filter((code) => pins.includes(code));
  if (allowed.length === 0) return null;

  const indices = allowed.map((code) => PIN_ORDER.indexOf(code));
  const isTopContiguous =
    indices[0] > 0 &&
    indices[indices.length - 1] === PIN_ORDER.length - 1 &&
    indices.every((value, i) => i === 0 || value === indices[i - 1] + 1);

  return isTopContiguous
    ? `${PIN_LABEL[allowed[0]]} & Above`
    : allowed
        .map((code) => PIN_LABEL[code])
        .join(", ")
        .replace(/, ([^,]*)$/, " & $1");
};

export function describePermission(
  product,
  iboPinCode = "IBO",
  iboMembershipCode = "C"
) {
  const pins = product?.audiencePinCodes;
  const mems = product?.audienceMembershipCodes;

  const pinRestricted =
    Array.isArray(pins) && pins.length > 0 && !pins.includes(iboPinCode);
  const memRestricted =
    Array.isArray(mems) && mems.length > 0 && !mems.includes(iboMembershipCode);

  if (!pinRestricted && !memRestricted) return null;

  const reasons = [];

  if (pinRestricted) {
    const phrase = buildPinPhrase(pins);
    if (phrase) {
      reasons.push(`pin level: ${phrase}`);
    }
  }

  if (memRestricted) {
    const memPhrase = mems
      .map((code) => MEMBERSHIP_LABEL[code] || code)
      .join(", ");
    if (memPhrase) {
      reasons.push(`membership: ${memPhrase}`);
    }
  }

  if (reasons.length === 0) return null;

  const combined = reasons.join(" with ");

  return `This product is currently available to ${combined} only. Would you like to override and add to the cart?`;
}
